import * as yup from "yup";

export const isObjEmpty = (obj: any) => Object.keys(obj).length === 0

// ** Returns K format from a number
export const kFormatter = (num: any) => (num > 999 ? `${(num / 1000).toFixed(1)}k` : num)

// ** Converts HTML to string
export const htmlToString = (html: any) => html.replace(/<\/?[^>]+(>|$)/g, '')

// ** Checks if the passed date is today
const isToday = (date: any) => {
    const today = new Date()
    return (
        /* eslint-disable operator-linebreak */
        date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear()
        /* eslint-enable */
    )
}
export const convertTimestampToDate = (
    timestamp: number,
    locale: string,
    timeZone?: string // örn: "GMT+03:00"
): string => {
    const date = new Date(timestamp);

    let timeZoneOption: string | undefined = undefined;
    let displayTimeZone: string = '';

    if (timeZone?.startsWith("GMT")) {
        const match = timeZone.match(/GMT([+-])(\d{2}):(\d{2})/);
        if (match) {
            const sign = match[1] === "+" ? "-" : "+";
            const hours = parseInt(match[2], 10);
            timeZoneOption = `Etc/GMT${sign}${hours}`;
            displayTimeZone = ` (GMT${match[1]}${parseInt(match[2], 10)})`;
        }
    }

    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: timeZoneOption
    };

    const formatter = new Intl.DateTimeFormat(locale, options);
    return `${formatter.format(date)}${displayTimeZone}`;
};

type Library = "places" | "geometry" | "drawing";
export const libraries: Library[] = ["places"];


/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (value: any, formatting: any = {month: 'numeric', day: 'numeric', year: 'numeric'}) => {
    if (!value) return value
    return new Intl.DateTimeFormat('tr-TR', formatting).format(new Date(value))
}

// ** Returns short month of passed date
export const formatDateToMonthShort = (value: any, toTimeForCurrentDay = true) => {
    const date = new Date(value)
    let formatting: Intl.DateTimeFormatOptions = {month: 'short', day: 'numeric'} // Specify type

    if (toTimeForCurrentDay && isToday(date)) {
        formatting = {hour: 'numeric', minute: 'numeric'}
    }

    return new Intl.DateTimeFormat('en-US', formatting).format(date)
}

/**
 ** Return if user is logged in
 ** This is completely up to you and how you want to store the token in your frontend application
 *  ? e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () => localStorage.getItem('userData');
export const getUserData = () => {
    const userData = localStorage.getItem('userData') || '{}'
    return JSON.parse(userData)
}
export const validations = {
    username: yup.string().required("Username Is Required"),
    password: yup.string().matches(/^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9]).{8,}$/g, "Password Validation").required("This Field Is Required"),

}